import { FormDialog } from "components/dialogs/Dialogs";
import { intl } from "LocaleWrapper";
import DatePicker from "components/cck/DatePicker";
import { useState } from "react";
import { StatusEstimateType } from "__generated__/enums";
import { getEstimatedStatusLabel } from "view/statuses/utils/StatusUtils";
import { useMutation } from "@apollo/client";
import { gql } from "__generated__/gql";

type UpdateCargoEstimateTimeDialogProps = {
	cargoId: number;
	initialValue?: number;
	open: boolean;
	estimateType: StatusEstimateType | null | undefined;
	onClose: () => void;
	onSuccess?: () => void;
};

const UpdateCargoEstimateTimeDialog = ({
	cargoId,
	initialValue,
	open,
	estimateType,
	onClose,
	onSuccess,
}: UpdateCargoEstimateTimeDialogProps) => {
	const [ value, setValue ] = useState<number | undefined>(initialValue);
	const [ updateCargoEstimateTime, { loading } ] = useMutation(updateCargoEstimateTimeMutation);

	const handleSave = (e: React.FormEvent) => {
		e.preventDefault();
		updateCargoEstimateTime({
			variables: {
				cargoId,
				estimate: value ?? null,
			},
		}).then(() => {
			onSuccess?.();
			onClose();
		});
	};

	return (
		<FormDialog
			open={open}
			onClose={onClose}
			title={getEstimatedStatusLabel(estimateType)}
			form="updateCargoEstimateTimeForm"
			loading={loading}
			maxWidth="sm"
		>
			<form onSubmit={handleSave} id="updateCargoEstimateTimeForm">
				<DatePicker
					value={value ?? null}
					onChange={(val) => setValue(val ?? undefined)}
					showTimeInput
					autoFocus
				/>
			</form>
		</FormDialog>
	);
};

const updateCargoEstimateTimeMutation = gql(`#graphql
	mutation updateCargoEstimateTime($cargoId: Long!, $estimate: Instant) {
		updateCargoEstimateTime(cargoId: $cargoId, estimate: $estimate)
	}
`);

export default UpdateCargoEstimateTimeDialog;
